<template>
    <div id="r2s4">
        <h2 class="title">
            {{ $t('f_r2s4_title') }}
            <info-tip
                class="bottom right-content"
                :text="$t('f_r2s4_title_tip_text')" />
        </h2>

        <div v-if="$device.mobile()" class="inline-input yes-no-wrap">
            <div class="own-input">
                <label class="checkbox-container">
                    {{ $t('f_yes') }}
                    <input v-model="is_expenses" :value="true" type="radio">
                    <span class="checkmark" />
                </label>
            </div>
            <div class="own-input">
                <label class="checkbox-container">
                    {{ $t('f_no') }}
                    <input v-model="is_expenses" :value="false" type="radio">
                    <span class="checkmark" />
                </label>
            </div>
        </div>

        <div v-else class="inline-desktop inline-input">
            <div class="own-input">
                <div class="check-btn">
                    <input
                        id="haveAdditionalCost-yes"
                        v-model="is_expenses"
                        :value="true"
                        type="radio">
                    <label for="haveAdditionalCost-yes">
                        {{ $t('f_yes') }}
                    </label>
                </div>
            </div>
            <div class="own-input">
                <div class="check-btn">
                    <input
                        id="haveAdditionalCost-no"
                        v-model="is_expenses"
                        :value="false"
                        type="radio">
                    <label for="haveAdditionalCost-no">
                        {{ $t('f_no') }}
                    </label>
                </div>
            </div>
        </div>

        <div v-show="is_expenses" class="additional-costs">
            <r2s4expense
                v-for="(expense, i) of filteredExpensesList"
                :key="i"
                :index="i"
                :expense="expense" />
            <div class="add-cost" @click="addExpense">
                <b>+</b> <span>{{ $t('f_add_cost_btn') }}</span>
            </div>
        </div>

        <server-errors v-if="serversErrors" :message="serversErrors" />
        <div class="own-input next-prev-wrap">
            <div class="btn btn-link prev" @click="prevStep">
                &#10092; {{ $t('f_back') }}
            </div>
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(), 'progress': loading}]" @click="next">
                <span v-show="!loading">{{ $t('f_continue') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import R2s4expense from './R2s4expense'
  import formNavMixin from '../mixins/formNavMixin'

  const { mapMultiRowFields } = createHelpers({
    getterType: 'expenses/getField',
    mutationType: 'expenses/updateField'
  })

  export default {
    components: { R2s4expense },
    mixins: [formNavMixin],
    data(){
      return {
        module: 'round2'
      }
    },
    computed: {
      is_expenses: {
        set: function (newVal) {
          this.$store.commit('expenses/TOGGLE', newVal)
          if (this.filteredExpensesList.length == 0 && newVal == true) { this.$store.commit('expenses/ADD') }
        },
        get: function () {
          return this.$store.getters['expenses/getField']('is_expenses')
        }
      },
      ...mapMultiRowFields({
        expenses: 'list'
      }),
      filteredExpensesList: function(){
        return this.expenses.filter((expense) => !expense.for_destroy)
      }
    },
    methods: {
      ...mapMutations({
        addExpense: 'expenses/ADD'
      }),
      next(){
        this.formSubmittion({scope: `*`, formSelector: '#r2s4'}).then(({success, fail}) => {
          this.$store.dispatch("round2/putAuthorization", this.$store.getters['round2/r2s4FormData']).then(()=> {
            this.$store.commit('round2/NEXT_STEP')
            success()
          }).catch((response) => {
            fail(response)
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  #r2s4 {
    .title {
      font-size: 18px;
      font-weight: 300;
      position: relative;
      .content {
        // top: 51px;
        bottom: auto !important;
        // top: 26px;
        top: auto;
      }
    }

    .additional-costs {
      margin-top: 20px;

      .add-cost {
        color: $orange_a;
        cursor: pointer;
        font-size: 18px;
        padding-bottom: 10px;
        border-bottom: 1px solid $light_gray_a;

        > b {
          line-height: 0;
          font-size: 30px;
          vertical-align: middle;
        }
        &:hover{
          span{ text-decoration: underline; }
        }
      }
    }
  }
</style>